export function getOriginUrl() {
  return window.location.origin;
}